export default "__VITE_ASSET__DexrHYu0__"